export enum EstadoUpload {
    Preparando = "Preparando",
    Subiendo = "Subiendo",
    Importando = "Importando",
    Finalizado = "Finalizado",
    Cancelado = "Cancelado",
    Error = "Error"
}